import React from 'react';
import cx from 'classnames';
import { Link } from 'ha/ui.legacy/Link';
import { isInternalWithSubdomain } from 'ha/utils/urls/isInternalWithSubdomain';
import { isExternalUrl } from 'ha/utils/urls/isExternalUrl';
import { fixHref } from 'ha/utils/urls/fixHref';
import { parse } from 'ha/utils/urls/parse';

const MarkdownLink = ({ children, className, href, ...rest }) => {
  const fixedHref = fixHref(href);

  if (isExternalUrl(href) || isInternalWithSubdomain(href)) {
    // external link
    return (
      <Link
        {...rest}
        href={fixedHref}
        target="_blank"
        className={cx('md__link', className)}
      >
        {children}
      </Link>
    );
  }

  const parsedHref = parse(fixedHref);

  return (
    <Link
      {...rest}
      href={`${parsedHref.pathname}${parsedHref.search || ''}`}
      className={cx('md__link', className)}
      target="_blank"
    >
      {children}
    </Link>
  );
};

export { MarkdownLink };
